import type { NavigateFunction, NavigateOptions } from "react-router-dom";
import trpc from "@/shared/utils/trpc";

/** Workspace URL for a partner company (existing match or preview shell). */
export async function resolveCompanyWorkspacePath(companyId: string): Promise<string> {
  try {
    const match = await trpc.collaboration.getByCompanyId.query({ targetCompanyId: companyId });
    if (match?.id) return `/collaborations/${match.id}`;
  } catch {
    // No match or not authenticated — fall through to preview route.
  }
  return `/collaborations/company/${companyId}`;
}

export async function navigateToCompanyWorkspace(
  navigate: NavigateFunction,
  companyId: string,
  options?: NavigateOptions & { search?: string },
): Promise<void> {
  const path = await resolveCompanyWorkspacePath(companyId);
  const rawSearch = options?.search?.trim();
  const search = rawSearch ? (rawSearch.startsWith("?") ? rawSearch : `?${rawSearch}`) : "";
  const { search: _search, ...navOptions } = options ?? {};
  navigate(`${path}${search}`, navOptions);
}
